// extracted by mini-css-extract-plugin
export default {"imprint":"Imprint_imprint__97yyW","title":"Imprint_title__tzpYP","attribution":"Imprint_attribution__zGOFT"};